var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C14.3783 24 12.3434 23.1571 10.8431 21.6569C9.34285 20.1566 8.5 18.1217 8.5 16C8.5 13.8783 9.34285 11.8434 10.8431 10.3431C12.3434 8.84285 14.3783 8 16.5 8C18.6217 8 20.6566 8.84285 22.1569 10.3431C23.6571 11.8434 24.5 13.8783 24.5 16V48C24.5 50.1217 23.6571 52.1566 22.1569 53.6569C20.6566 55.1571 18.6217 56 16.5 56C14.3783 56 12.3434 55.1571 10.8431 53.6569C9.34285 52.1566 8.5 50.1217 8.5 48C8.5 45.8783 9.34285 43.8434 10.8431 42.3431C12.3434 40.8429 14.3783 40 16.5 40H48.5C50.6217 40 52.6566 40.8429 54.1569 42.3431C55.6571 43.8434 56.5 45.8783 56.5 48C56.5 50.1217 55.6571 52.1566 54.1569 53.6569C52.6566 55.1571 50.6217 56 48.5 56C46.3783 56 44.3434 55.1571 42.8431 53.6569C41.3429 52.1566 40.5 50.1217 40.5 48V16C40.5 13.8783 41.3429 11.8434 42.8431 10.3431C44.3434 8.84285 46.3783 8 48.5 8C50.6217 8 52.6566 8.84285 54.1569 10.3431C55.6571 11.8434 56.5 13.8783 56.5 16C56.5 18.1217 55.6571 20.1566 54.1569 21.6569C52.6566 23.1571 50.6217 24 48.5 24H16.5Z",
    stroke: "#757575",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.62759857e3648d2e21bbab25a5842edc.svg";
export { ForwardRef as ReactComponent };